import { useMemo } from "react"
import { FeaturePermissionsTemplate, FeaturesPermissionsType } from "../../../../templates/templates"
import { FeaturePermissions } from "../../../../types"
import { CellComponentFunction } from "../../types"
import { DropDown } from "./Dropdown"
import { Option, Options, accessOptions, notAvailableOption, readWriteOptions, readWriteWithFinancialDataOptions } from "./options"
import { classes } from "../../../../../../../../shared/react/react"
import { isFunction, isString } from "../../../../../../../../shared/utils/utils"

export const Components: { [type in FeaturesPermissionsType]: CellComponentFunction } = {
    "readWrite": ReadWritePermissionsCell,
    "readWriteFinancial": ReadWriteWithFinancialDataPermissionsCell,
    "access": AccessPermissionsCell
}

interface Props {
    template: FeaturePermissionsTemplate<{}>
    feature: FeaturePermissions
    available: boolean
    readOnly: boolean
    setPermissions?(permissions: FeaturePermissions["values"]): void
}

function AccessPermissionsCell(props: Props) {
    return <Cell
        {...props}
        options={accessOptions}
    />
}

function ReadWritePermissionsCell(props: Props) {
    return <Cell
        {...props}
        options={readWriteOptions}
    />
}

function ReadWriteWithFinancialDataPermissionsCell(props: Props) {
    return <Cell
        {...props}
        options={readWriteWithFinancialDataOptions}
    />
}


interface PropsWithOptions {
    options: Options
    feature: FeaturePermissions
    setPermissions?(permissions: {}): void
    available: boolean
    readOnly: boolean
}

function Cell({ options, feature, available, setPermissions, readOnly }: PropsWithOptions) {

    const values = feature.values ?? feature.defaultValues
    const { availability } = feature

    readOnly ||= !isFunction(setPermissions)

    const selected = useMemo(() => {
        const key = options.keys.filter(key => Boolean(values[key])).join(",")
        return options.options.find(o => o.key === key) ?? notAvailableOption
    }, [options, feature.values])


    const select = (option: Option) => setPermissions(option.values)
    const notAvailable = !(availability.member && availability.owner && (available ?? true))

    const [title, icon] = notAvailable
        ? ["Not available", "fa-solid fa-ban"]
        : [selected.name, selected.icon]

    if (readOnly) {

        return <div title={title}>
            {
                isString(icon)
                    ? <i className={icon} />
                    : <>{icon}</>
            }
        </div>
    }

    return <div className={classes("dropdown-cell", selected.cellCssClass, feature.updated && "updated", notAvailable && "disabled")} title={title}>

        <DropDown
            buttonIcon={icon}
            options={options.options}
            select={select}
            isSelected={o => o.key === selected.key}
            includeSelectedIcon={true}
            disabled={notAvailable}
        />

    </div>

}
